var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.563 3.87268C14.1943 3.88176 15.0777 3.9541 15.654 4.53039C16.313 5.1894 16.313 6.25006 16.313 8.37138V12.8714C16.313 14.9927 16.313 16.0534 15.654 16.7124C14.995 17.3714 13.9343 17.3714 11.813 17.3714H7.31299C5.19167 17.3714 4.13101 17.3714 3.472 16.7124C2.81299 16.0534 2.81299 14.9927 2.81299 12.8714V8.37138C2.81299 6.25006 2.81299 5.1894 3.472 4.53039C4.04829 3.9541 4.93172 3.88176 6.56299 3.87268",
    stroke: "#44546F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43799 11.3713L13.313 11.3713",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81299 11.3713H6.18799",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81299 8.74634H6.18799",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81299 13.9963H6.18799",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43799 8.74634H13.313",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43799 13.9963H13.313",
    stroke: "#44546F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56299 3.49634C6.56299 2.87502 7.06667 2.37134 7.68799 2.37134H11.438C12.0593 2.37134 12.563 2.87502 12.563 3.49634V4.24634C12.563 4.86766 12.0593 5.37134 11.438 5.37134H7.68799C7.06667 5.37134 6.56299 4.86766 6.56299 4.24634V3.49634Z",
    stroke: "#44546F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCount);
export default __webpack_public_path__ + "static/media/Question_Count.4104a1998f2475cedb6f9adb8825dcb2.svg";
export { ForwardRef as ReactComponent };